import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card } from "@/components/UI";
import { PRICE_FIELDS, CURRENCIES, fmtNum } from "@/lib/products";

// Display-only FX helper; never changes the stored purchase price.
function convert(amount, from, to, rates) {
  const toTry = (c) => (c === "TRY" ? 1 : rates[c]);
  if (!toTry(from) || !toTry(to)) return null;
  return (amount * toTry(from)) / toTry(to);
}

export function ProductPricing({ product }) {
  const [fx, setFx] = useState(null);
  useEffect(() => { api.get("/fx/rates").then(setFx).catch(() => setFx(null)); }, []);
  const others = CURRENCIES.filter((c) => c !== product.purchase_currency);
  return (
    <Card className="p-5" data-testid="product-pricing">
      <div className="text-sm font-semibold text-slate-700 mb-3">Fiyatlar</div>
      <div className="flex items-baseline justify-between border-b border-slate-100 pb-2 mb-2">
        <span className="text-xs uppercase tracking-wider text-slate-500">Alış Fiyatı</span>
        <span className="font-semibold" data-testid="prod-detail-purchase">{fmtNum(product.purchase_price)} {product.purchase_currency}</span>
      </div>
      {fx?.rates && (
        <div className="text-[11px] text-slate-500 mb-3" data-testid="prod-detail-fx">
          ≈ {others.map((c) => {
            const v = convert(product.purchase_price || 0, product.purchase_currency, c, fx.rates);
            return v === null ? null : `${fmtNum(v)} ${c}`;
          }).filter(Boolean).join(" · ")} <span className="italic">(TCMB {fx.rate_date}, yalnız bilgi)</span>
        </div>
      )}
      {PRICE_FIELDS.map((p) => (
        <div key={p.key} className="flex items-baseline justify-between py-1">
          <span className="text-sm text-slate-600">{p.label}</span>
          <span className="font-medium" data-testid={`prod-detail-${p.key}`}>{fmtNum(product[p.key])} TRY</span>
        </div>
      ))}
    </Card>
  );
}
